import { defineConfig } from "../utils/define-config";

export { defineConfig };
